<template>
  <AsyncPage
    :loader="useCreditStatementLoader"
    :page-component="CreditStatement"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useCreditStatementLoader } from "./CreditStatement.loader.ts";
import { credit_statement as strings } from "./CreditStatement.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

useAsyncPageDocumentTitle(strings.documentTitle);

const CreditStatement = defineAsyncComponent(
  () => import("./CreditStatement.vue"),
);
</script>
